// Import necessary dependencies from React and Material-UI
import { useState } from "react";
import Drawer from "@mui/material/Drawer";
import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
import { IconButton } from "@mui/material";
import { Link } from "react-router-dom";

// Import custom styles for the Drawer component from an external CSS file
import "./drawer.css";

/**
 * TemporaryDrawer component renders a responsive drawer for navigation.
 * @returns {JSX.Element} - TemporaryDrawer component.
 */
export default function TemporaryDrawer() {
  // State to manage the open/closed state of the drawer
  const [open, setOpen] = useState(false);

  return (
    <div>
      {/* IconButton to open the drawer */}
      <IconButton sx={{ paddingRight: 0 }} onClick={() => setOpen(true)}>
        {/* Menu icon */}
        <MenuRoundedIcon sx={{ color: "white" }} className="link21" />
      </IconButton>

      {/* Drawer component for navigation links */}
      <Drawer anchor={"left"} open={open} onClose={() => setOpen(false)}>
        {/* Content inside the drawer */}
        <div className="drawer-div">
          <div>
            {/* Link to the homepage */}
            <Link to="/">
              <p className="link21">InsightCoin</p>
            </Link>
            {/* Horizontal line as a separator */}
            <hr />
          </div>

          {/* Navigation links */}
          <Link to="/">
            <p className="link21">Home</p>
          </Link>
          <Link to="/coins">
            <p className="link21">Coins</p>
          </Link>
          <Link to="/compare">
            <p className="link21">Compare</p>
          </Link>
          <Link to="/starred">
            <p className="link21">Starred</p>
          </Link>
        </div>
      </Drawer>
    </div>
  );
}
